import { ThemeEngine } from '@runtime/core/theme/themeEngine'
import type { ResolvedPosterThemeConfig } from '@runtime/core/theme/posterThemes'

type CommitPosterThemeSelectionArgs = {
  themeId: string
  cfg: ResolvedPosterThemeConfig
  setThemeId: (themeId: string) => void
}

export function commitPosterThemeSelection({
  themeId,
  cfg,
  setThemeId,
}: CommitPosterThemeSelectionArgs) {
  const nextThemeId = String(cfg.id || themeId).trim() || themeId
  ThemeEngine.applyFromConfig(cfg)
  setThemeId(nextThemeId)
}
